import {
    buildConfigSliceWithGridSupport,
    useConfigSlice,
    WidgetConfigSliceActionPayloadType,
} from 'widgets/store/configuration/configSlice';
import { WidgetType } from 'widgets/WidgetType';
import {
    IndexEventsWidgetConfigState,
    initialIndexEventsConfiguration,
} from './IndexEventsWidgetConfigState';
import { selectIndexEventsState } from '../selectors';

export const buildIndexEventsConfigSlice = () =>
    buildConfigSliceWithGridSupport(
        WidgetType.INDEX_EVENTS,
        selectIndexEventsState,
        initialIndexEventsConfiguration
    );

export const useIndexEventsConfigSlice = () =>
    useConfigSlice(buildIndexEventsConfigSlice());

export type IndexEventsConfigPayloadType =
    WidgetConfigSliceActionPayloadType<IndexEventsWidgetConfigState>;
